import { ShoppingCartItem } from '../cart/shopping.cart.item';
import { TimingObject } from '../common/timing.object';

export class CartItemsResponse {
  CartItems: { [key: string]: ShoppingCartItem };
  Timing: TimingObject;
}
